import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './helpers/i18n';
import App from './App';
import Loader from './resources/views/components/Loader';

ReactDOM.render(<Suspense fallback={<Loader />}><App /></Suspense>, document.getElementById('root'));
